import { useEffect } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import {
  MdOutlineZoomIn,
  MdOutlineZoomOut,
  MdFullscreen,
} from "react-icons/md";
import { TbBoxMultiple } from "react-icons/tb";
import { FaRegCirclePlay } from "react-icons/fa6";
import "react-photo-view/dist/react-photo-view.css";
import "../PhotoGalleryPage/photoGallery.scss";

// Add your new Photo Gallery images here (Once added into the folder - public/img/photo-gallery)
const articleImgs = [
  "/article_imgs/article14.jpeg",
  "/article_imgs/article13.jpeg",
  "/article_imgs/1.JPG",
  "/article_imgs/2.JPG",
  "/article_imgs/3.JPG",
  "/article_imgs/4.JPG",
  "/article_imgs/5.JPG",
  "/article_imgs/6.JPG",
  "/article_imgs/7.JPG",
  "/article_imgs/8.JPG",
  "/article_imgs/9.JPG",
  "/article_imgs/10.JPG",
  "/article_imgs/11.JPG",
  "/article_imgs/12.JPG",
  "/article_imgs/13.JPG",
  "/article_imgs/14.JPG",
  "/article_imgs/15.JPG",
  "/article_imgs/16.JPG",
  "/article_imgs/17.JPG",
  "/article_imgs/18.JPG",
  "/article_imgs/19.JPG",
  "/article_imgs/20.JPG",
  "/article_imgs/21.JPG",
  "/article_imgs/22.JPG",
  "/article_imgs/23.JPG",
  "/article_imgs/24.JPG",
  "/article_imgs/25.JPG",
  "/article_imgs/26.JPG",
];

const ArticleImgs = () => {
  useEffect(() => {
    document.title = "Articles | Mango Holidays";
  }, []);

  return (
    <>
      {/* Banner Section */}
      <section className="banner-section-photoGallery">
        <div className="img-container-photoGallery">
          <img src="/img/photo-gallery.webp" alt="Banner Unavailable" />
        </div>
        <div className="banner-overlay-photoGallery">
          <h1 className="banner-title-photoGallery">Articles</h1>
        </div>
      </section>

      {/* Photos Section */}
      <section className="photos-section">
        <PhotoProvider
          maskOpacity={0}
          loop={true}
          toolbarRender={({ onScale, scale, onFullscreen, loop }) => (
            <div className="photo-provider-toolbar">
              <button>
                <TbBoxMultiple />
              </button>
              <button onClick={() => onScale(scale + 1)} title="Zoom In">
                <MdOutlineZoomIn />
              </button>
              <button onClick={() => onScale(scale - 1)} title="Zoom Out">
                <MdOutlineZoomOut />
              </button>
              <button onClick={onFullscreen} title="Fullscreen">
                <MdFullscreen />
              </button>
              <button onClick={loop} title="Loop">
                <FaRegCirclePlay />
              </button>
            </div>
          )}
        >
          {articleImgs.map((imageSrc, index) => (
            <div key={index} className="article-image-container">
              <PhotoView src={process.env.PUBLIC_URL + imageSrc}>
                <img
                  src={process.env.PUBLIC_URL + imageSrc}
                  alt={`Travel ${index + 1}`}
                />
              </PhotoView>
            </div>
          ))}
        </PhotoProvider>
      </section>
    </>
  );
};

export default ArticleImgs;
